


        <app-type-duree-marche id="step6"  [uid]="getUid()" [parentForm]="parentForm"
		[disabled]="disabled"
		 [typeDureeMarche]="initial.duree"></app-type-duree-marche>
		<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>


